import { redirectToPage } from "@client/actions";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import classNames from "classnames";
import Component, { type LinkProps } from "./component";

const mapStateToProps = (state: AppState, props: Omit<LinkProps, "isEditMode">): LinkProps => ({
  ...props,
  isDisabled: props.isDisabled || state.isEditMode
});

export default connectCustom(mapStateToProps)(Component);

type PageLinkProps = Omit<LinkProps, "isEditMode" | "to"> & {
  pageId: string;
};
export const PageLink = connectCustom(
  (state: AppState, props: PageLinkProps): LinkProps => ({
    ...props,
    className: classNames(props.className, "pointer"),
    isDisabled: props.isDisabled || state.isEditMode
  }),
  (dispatch: any, props: PageLinkProps): Pick<LinkProps, "onClick"> => ({
    onClick: () => dispatch(redirectToPage(props.pageId))
  })
)(Component);
